module.exports = __webpack_public_path__ + "img/icon-close-black.b9b07106.svg";